module.exports = __webpack_public_path__ + "static/media/md-hammer.4b5f5a3f.svg";